import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DemandModalData } from 'src/assets/types/interface/demand-modal-data.interface';
import { Environment } from 'src/assets/types/interface/environment.interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EntityExtractorService {
  private readonly apiUrl = environment.WO_API_URL;
  constructor(private http: HttpClient) {}

  recommendCompanyEnvironment(data: {
    text: string;
    light?: boolean;
  }): Observable<DemandModalData> {
    const access_token = localStorage.getItem('access_token') ?? '';
    data.light = true;
    return this.http.post<DemandModalData>(
      `${this.apiUrl}/entity-extractor/recommend-company-environment`,
      data,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      },
    );
  }

  recommendEnvironment(data: {
    text: string;
    companyUuid: string;
  }): Observable<{
    enviroments: Environment[];
  }> {
    const access_token = localStorage.getItem('access_token');
    return this.http.post<{ enviroments: Environment[] }>(
      `${this.apiUrl}/entity-extractor/recommend-environment`,
      data,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      },
    );
  }
}
